import { render, staticRenderFns } from "./OnboardTenant.vue?vue&type=template&id=57782b22&scoped=true&"
import script from "./OnboardTenant.vue?vue&type=script&lang=js&"
export * from "./OnboardTenant.vue?vue&type=script&lang=js&"
import style0 from "./OnboardTenant.vue?vue&type=style&index=0&id=57782b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57782b22",
  null
  
)

export default component.exports